// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopifyBlurredLayout_container__1tZZc","image":"ShopifyBlurredLayout_image__1LClJ","action":"ShopifyBlurredLayout_action__EdUzp"};